var $0e8100edb3f9d028$var$__defProp = Object.defineProperty;
var $0e8100edb3f9d028$var$__defProps = Object.defineProperties;
var $0e8100edb3f9d028$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0e8100edb3f9d028$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0e8100edb3f9d028$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0e8100edb3f9d028$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0e8100edb3f9d028$var$__defNormalProp = (obj, key, value)=>key in obj ? $0e8100edb3f9d028$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0e8100edb3f9d028$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0e8100edb3f9d028$var$__hasOwnProp.call(b, prop)) $0e8100edb3f9d028$var$__defNormalProp(a, prop, b[prop]);
    if ($0e8100edb3f9d028$var$__getOwnPropSymbols) {
        for (var prop of $0e8100edb3f9d028$var$__getOwnPropSymbols(b))if ($0e8100edb3f9d028$var$__propIsEnum.call(b, prop)) $0e8100edb3f9d028$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0e8100edb3f9d028$var$__spreadProps = (a, b)=>$0e8100edb3f9d028$var$__defProps(a, $0e8100edb3f9d028$var$__getOwnPropDescs(b));
var $0e8100edb3f9d028$var$__publicField = (obj, key, value)=>{
    $0e8100edb3f9d028$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $0e8100edb3f9d028$var$termynal = "";
var $0e8100edb3f9d028$export$aa318e0578993894 = /* @__PURE__ */ ((LineType2)=>{
    LineType2["INPUT"] = "input";
    LineType2["OUTPUT"] = "output";
    LineType2["PROGRESS"] = "progress";
    return LineType2;
})($0e8100edb3f9d028$export$aa318e0578993894 || {});
const $0e8100edb3f9d028$var$DefaultOptions = {
    prefix: "ty",
    startDelay: 600,
    typeDelay: 50,
    lineDelay: 1500,
    progressLength: 40,
    progressChar: "\u2588",
    progressPercent: 100,
    cursor: "\u258B",
    autoplay: false,
    className: ""
};
class $0e8100edb3f9d028$export$2e2bcd8739ae039 {
    constructor(container = "#termynal", options = {}, lineData = []){
        $0e8100edb3f9d028$var$__publicField(this, "container");
        $0e8100edb3f9d028$var$__publicField(this, "options");
        $0e8100edb3f9d028$var$__publicField(this, "lines");
        const containerElement = typeof container === "string" ? document.querySelector(container) : container;
        if (!containerElement) throw new Error("Termynal container not found.");
        this.container = containerElement;
        this.options = this._mergeOptions(options);
        this.lines = lineData;
        if (this.options.autoplay) this.init();
    }
    init() {
        this.lines = this._ElementsToLineData(Array.from(this.container.querySelectorAll(`[data-${this.options.prefix}]`))).concat(this.lines);
        const containerStyle = getComputedStyle(this.container);
        containerStyle.width !== "0px" && (this.container.style.width = containerStyle.width);
        containerStyle.height !== "0px" && (this.container.style.minHeight = containerStyle.height);
        this.container.setAttribute("data-termynal", "");
        this.container.innerHTML = "";
        this.start();
    }
    _mergeOptions(options) {
        const attrOptions = {};
        const dataset = this.container.dataset;
        dataset["startDelay"] && (attrOptions["startDelay"] = parseFloat(dataset["startDelay"]));
        dataset["typeDelay"] && (attrOptions["typeDelay"] = parseFloat(dataset["typeDelay"]));
        dataset["lineDelay"] && (attrOptions["lineDelay"] = parseFloat(dataset["lineDelay"]));
        dataset["progressLength"] && (attrOptions["progressLength"] = parseFloat(dataset["progressLength"]));
        dataset["progressChar"] && (attrOptions["progressChar"] = dataset["progressChar"]);
        dataset["progressPercent"] && (attrOptions["progressPercent"] = parseFloat(dataset["progressPercent"]));
        dataset["cursor"] && (attrOptions["cursor"] = dataset["cursor"]);
        return $0e8100edb3f9d028$var$__spreadValues($0e8100edb3f9d028$var$__spreadValues($0e8100edb3f9d028$var$__spreadValues({}, $0e8100edb3f9d028$var$DefaultOptions), options), attrOptions);
    }
    async start() {
        await this._wait(this.options.startDelay);
        for (const line of this.lines){
            const type = line.type || $0e8100edb3f9d028$export$aa318e0578993894.OUTPUT;
            const delay = line.delay || this.options.lineDelay;
            const el = document.createElement("pre");
            switch(type){
                case $0e8100edb3f9d028$export$aa318e0578993894.PROGRESS:
                    await this.progress(line);
                    break;
                case $0e8100edb3f9d028$export$aa318e0578993894.INPUT:
                    await this.type(line);
                    break;
                default:
                    el.className = "terymnal-output " + line.className;
                    el.innerText = line.value || "";
                    this.container.appendChild(el);
            }
            await this._wait(delay);
        }
    }
    async type(line) {
        var _a;
        const chars = ((_a = line.value) == null ? void 0 : _a.split("")) || [];
        const delay = line.typeDelay || this.options.typeDelay;
        const el = document.createElement("pre");
        el.className = "terymnal-input " + line.className;
        el.textContent = line.prompt ? `${line.prompt} ` : "";
        this.container.appendChild(el);
        for (const char of chars){
            await this._wait(delay);
            el.textContent += char;
        }
    }
    async progress(line) {
        const progressLength = line.progressLength || this.options.progressLength;
        const progressChar = line.progressChar || this.options.progressChar;
        const progressPercent = line.progressPercent || this.options.progressPercent;
        const chars = progressChar.repeat(progressLength);
        const el = document.createElement("pre");
        el.className = "terymnal-input " + line.className;
        el.textContent = "";
        this.container.appendChild(el);
        const typeDelay = line.typeDelay || this.options.typeDelay;
        for(let i = 0; i <= progressLength; i++){
            await this._wait(typeDelay);
            const percent = Math.round(i / progressLength * 100);
            el.textContent = `${chars.slice(0, i + 1)} ${percent}%`;
            if (percent > progressPercent) break;
        }
    }
    _wait(time) {
        return new Promise((resolve)=>setTimeout(resolve, time));
    }
    _ElementsToLineData(lineData) {
        return lineData.map((line)=>{
            const data = $0e8100edb3f9d028$var$__spreadProps($0e8100edb3f9d028$var$__spreadValues({}, this._getLineAttributes(line)), {
                type: line.getAttribute(`data-${this.options.prefix}`) || $0e8100edb3f9d028$export$aa318e0578993894.OUTPUT,
                value: line.textContent || ""
            });
            return data;
        });
    }
    _getLineAttributes(el) {
        const options = {
            delay: this._getAttributeAsFloat(el, "delay") || this.options.lineDelay,
            startDelay: this._getAttributeAsFloat(el, "startDelay") || this.options.startDelay,
            typeDelay: this._getAttributeAsFloat(el, "typeDelay") || this.options.typeDelay,
            progressLength: this._getAttributeAsFloat(el, "progressLength") || this.options.progressLength,
            progressChar: el.getAttribute(`data-${this.options.prefix}-progressChar`) || this.options.progressChar,
            progressPercent: this._getAttributeAsFloat(el, "progressPercent") || this.options.progressPercent,
            cursor: el.getAttribute(`data-${this.options.prefix}-cursor`) || this.options.cursor,
            type: el.getAttribute(`data-${this.options.prefix}`) || $0e8100edb3f9d028$export$aa318e0578993894.INPUT,
            className: el.className || this.options.className
        };
        return options;
    }
    _getAttributeAsFloat(element, attribute) {
        const attrValue = element.getAttribute(`data-${this.options.prefix}-${attribute}`);
        return attrValue ? parseFloat(attrValue) : null;
    }
}


async function $2b6e161c9edcf319$var$nextContentPage() {
    let resolve = null;
    const promise = new Promise((res)=>{
        resolve = res;
    });
    const pageContent = document.querySelector(".page-content");
    const activePage = document.querySelector(".content-page.active");
    if (activePage) {
        activePage.classList.add("fade");
        activePage.classList.remove("active");
        activePage.inert = true;
        activePage.addEventListener("transitionend", ()=>{
            activePage.classList.remove("fade");
            if (pageContent) pageContent.scrollTo({
                top: 0
            });
            const nextPage = activePage.nextElementSibling;
            if (nextPage && nextPage.classList.contains("content-page")) {
                nextPage.classList.add("fade");
                nextPage.offsetWidth; // Trigger reflow
                nextPage.classList.add("active");
                nextPage.inert = false;
                nextPage.classList.remove("fade");
                nextPage.addEventListener("transitionend", ()=>{
                    resolve();
                }, {
                    once: true
                });
            }
        }, {
            once: true
        });
    }
    return promise;
}
async function $2b6e161c9edcf319$var$startTermynal() {
    const termynal = new (0, $0e8100edb3f9d028$export$2e2bcd8739ae039)("#autotype", {
        autoplay: true,
        startDelay: 0,
        typeDelay: 10,
        lineDelay: 400,
        progressLength: 30
    }, [
        {
            type: "input",
            value: "> Analiziram podatke..."
        },
        {
            type: "input",
            value: "> Preverjam vire..."
        },
        {
            type: "input",
            value: "> Dostopam do baze..."
        },
        {
            type: "progress",
            typeDelay: 30,
            delay: 1
        },
        {
            value: "DOSTOP ODOBREN."
        },
        {
            value: "> Odpiram arhiv...",
            delay: 1
        },
        {
            type: "progress",
            typeDelay: 10,
            delay: 1
        },
        {
            value: "> Ustvarjam profil...",
            delay: 1
        },
        {
            type: "progress",
            typeDelay: 60,
            delay: 1
        },
        {
            value: "PROFIL USTVARJEN.",
            delay: 1000
        },
        {
            value: "",
            className: "termynal-done"
        }
    ]);
    // listen for the element with class "termynal-done" to appear
    await new Promise((resolve)=>{
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations){
                for (const node of mutation.addedNodes)if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains("termynal-done")) {
                    observer.disconnect();
                    resolve();
                }
            }
        });
        observer.observe(termynal.container, {
            childList: true
        });
    });
}
const $2b6e161c9edcf319$var$NUM_RESULTS = 6;
const $2b6e161c9edcf319$var$RESULTS_OPTIONS = [
    {
        label: "\u0160tevilo oseb v imeniku, ki so na seznamu opazovancev 387-B",
        min: 2,
        max: 9
    },
    {
        label: "Trajanje povpre\u010Dnega klica ta mesec",
        min: 461,
        max: 672,
        type: "time_min_sec"
    },
    {
        label: "\u010Cas, pre\u017Eivet na straneh z eksplicitno vsebino v zadnjem letu",
        min: 97,
        max: 178,
        type: "time"
    },
    {
        label: "\u0160tevilo korakov v prvem tednu novembra",
        min: 39800,
        max: 47200
    },
    {
        label: "\u0160tevilo sporo\u010Dil z omembo besede \u201Ccena\u201D",
        min: 2,
        max: 6
    },
    {
        label: "\u0160tevilo sporo\u010Dil z omembo besede \u201Cbomba\u201D",
        min: 1,
        max: 4
    },
    {
        label: "\u0160tevilo poslanih sporo\u010Dil v prej\u0161njem tednu",
        min: 180,
        max: 310
    },
    {
        label: "\u0160tevilo posnetih videoposnetkov v zadnjem mesecu",
        min: 8,
        max: 16
    },
    {
        label: "\u0160tevilo oseb, s katerimi je potekala komunikacija v zadnjem tednu",
        min: 22,
        max: 41
    },
    {
        label: "\u0160tevilo pogovorov s povzdignjenim glasom v zadnjem mesecu",
        min: 5,
        max: 9
    },
    {
        label: "\u0160tevilo zgre\u0161enih klicev v zadnjem tednu",
        min: 7,
        max: 12
    },
    {
        label: "Oddaljenost najdalj\u0161ega klica od doma",
        min: 19,
        max: 28,
        type: "distance"
    },
    {
        label: "\u0160tevilo pre\u010Dkanj meje v zadnjem letu",
        min: 4,
        max: 10
    },
    {
        label: "\u0160tevilo ogledanih videov v zadnjih 72 urah",
        min: 31,
        max: 56
    },
    {
        label: "Povpre\u010Dna hitrost premikanja med 8. in 10. uro",
        min: 2.7,
        max: 3.6,
        type: "speed"
    },
    {
        label: "\u0160tevilo posnetih fotografij v zadnjem tednu",
        min: 32,
        max: 71
    },
    {
        label: "Najpogosteje poslu\u0161ana radijska postaja"
    },
    {
        label: "Povpre\u010Dna vrednost nakupa v spletni banki v zadnjem tednu",
        min: 28.9,
        max: 36.4,
        type: "currency"
    },
    // { label: "Trenutna vrednost baterije" },
    {
        label: "\u010Cas vklju\u010Denega zaslona v\u010Deraj",
        min: 298,
        max: 372,
        type: "time"
    },
    {
        label: "\u0160tevilo aplikacij, uporabljenih najmanj enkrat v zadnjem mesecu",
        min: 20,
        max: 34
    },
    {
        label: "Povpre\u010Dna sr\u010Dna frekvenca med spanjem danes pono\u010Di",
        min: 58,
        max: 67,
        type: "bpm"
    },
    {
        label: "Povpre\u010Dni \u010Das spanja v zadnjem tednu",
        min: 414,
        max: 463,
        type: "time"
    }
];
function $2b6e161c9edcf319$var$fixSavedData(parsedData, key) {
    if (!parsedData.fixVersion) parsedData.fixVersion = 0;
    if (parsedData.fixVersion < 1) {
        if (parsedData.label === "Trajanje povpre\u010Dnega klica ta mesec") {
            console.log("Fixing time format for:", parsedData);
            // fix time format from "X h Y min" to "X min Y s"
            const timeParts = /(\d+)\s*h\s*(\d+)\s*min/.exec(parsedData.value);
            if (timeParts) {
                const minutes = parseInt(timeParts[1], 10);
                const seconds = parseInt(timeParts[2], 10);
                const newValue = `${minutes} min ${seconds} s`;
                parsedData.value = newValue;
            }
        }
        parsedData.fixVersion = 1;
    }
    localStorage.setItem(key, JSON.stringify(parsedData));
    return parsedData;
}
function $2b6e161c9edcf319$var$loadResultValues() {
    const resultTemplate = document.querySelector(".js-result-template");
    const resultsSection = resultTemplate.closest(".results-section");
    if (resultsSection && resultTemplate) {
        const usedIndices = new Set();
        for(let i = 1; i <= $2b6e161c9edcf319$var$NUM_RESULTS; i++){
            const resultClone = resultTemplate.content.cloneNode(true);
            const resultLabel = resultClone.querySelector(".js-result-label");
            const resultValue = resultClone.querySelector(".js-result-value");
            if (resultLabel && resultValue) {
                const savedData = localStorage.getItem(`sova-result-data-${i}`);
                if (savedData && location.href.indexOf("sova-no-cache") === -1) {
                    const parsedData = $2b6e161c9edcf319$var$fixSavedData(JSON.parse(savedData), `sova-result-data-${i}`);
                    resultLabel.textContent = parsedData.label;
                    resultValue.textContent = parsedData.value;
                    resultClone.querySelector(".alert").classList.add(parsedData.class);
                    usedIndices.add(parsedData.optionIndex);
                    resultsSection.appendChild(resultClone);
                    continue;
                }
                let optionIndex = Math.floor(Math.random() * $2b6e161c9edcf319$var$RESULTS_OPTIONS.length);
                while(usedIndices.has(optionIndex))// ensure unique options
                optionIndex = Math.floor(Math.random() * $2b6e161c9edcf319$var$RESULTS_OPTIONS.length);
                usedIndices.add(optionIndex);
                const option = $2b6e161c9edcf319$var$RESULTS_OPTIONS[optionIndex];
                resultLabel.textContent = option.label;
                let className = option.class;
                if (!className) {
                    const rand = Math.random();
                    if (rand < 0.1) className = "ok";
                    else if (rand < 0.55) className = "warning";
                    else className = "danger";
                }
                resultClone.querySelector(".alert").classList.add(className);
                let value = "";
                if (option.min != null && option.max != null) {
                    const randomValueFloat = Math.random() * (option.max - option.min) + option.min;
                    const randomValue = Math.floor(randomValueFloat);
                    const formatter = new Intl.NumberFormat("sl-SI", {
                        maximumFractionDigits: 2
                    });
                    const formattedValue = formatter.format(randomValue);
                    const formattedValueFloat = formatter.format(randomValueFloat);
                    if (option.type === "time") {
                        const hours = Math.floor(randomValue / 60);
                        const minutes = randomValue % 60;
                        value = `${hours} h ${minutes} min`;
                    } else if (option.type === "time_min_sec") {
                        const minutes = Math.floor(randomValue / 60);
                        const seconds = randomValue % 60;
                        value = `${minutes} min ${seconds} s`;
                    } else if (option.type === "distance") value = `${formattedValueFloat} km`;
                    else if (option.type === "speed") value = `${formattedValueFloat} km/h`;
                    else if (option.type === "currency") value = `${formattedValueFloat} \u{20AC}`;
                    else if (option.type === "bpm") value = `${formattedValue} bpm`;
                    else value = `${formattedValue}`;
                } else if (option.values) {
                    const randomIndex = Math.floor(Math.random() * option.values.length);
                    value = option.values[randomIndex];
                } else value = "";
                resultValue.textContent = value;
                resultsSection.appendChild(resultClone);
                const dataToStore = {
                    label: option.label,
                    value: resultValue.textContent,
                    class: className,
                    optionIndex: optionIndex,
                    fixVersion: 1
                };
                localStorage.setItem(`sova-result-data-${i}`, JSON.stringify(dataToStore));
            }
        }
    }
}
function $2b6e161c9edcf319$var$selectEmailContent() {
    const emailContent = document.querySelector(".js-email-content");
    if (emailContent) {
        const range = document.createRange();
        range.selectNodeContents(emailContent);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        return selection;
    }
    return null;
}
function $2b6e161c9edcf319$var$addNewsletterListeners() {
    const form = document.querySelector(".content-footer .newsletter-form");
    if (form) {
        const emailEl = form.querySelector("#newsletter-email");
        const checkbox = form.querySelector("#newsletter-checkbox");
        const submit = form.querySelector("button[type=submit]");
        form.addEventListener("submit", (event)=>{
            event.preventDefault();
            const campaign_slug = "danes-je-nov-dan";
            const segment_id = 21;
            const email = emailEl.value;
            let url = `https://moj.djnd.si/${campaign_slug}/prijava?segment_id=${segment_id}`;
            url += `&email=${encodeURIComponent(email)}`;
            window.open(`${url}`, `_blank`);
        });
    }
}
function $2b6e161c9edcf319$var$skipToExplanationIfNeeded() {
    let pageClass = null;
    if (location.hash === "#razlaga") pageClass = "explanation";
    else if (location.hash === "#rezultati") pageClass = "results";
    if (!pageClass) return;
    const pages = document.querySelectorAll(".content-page");
    pages.forEach((page)=>{
        if (pageClass && page.classList.contains(pageClass)) {
            page.classList.add("active");
            page.inert = false;
        } else {
            page.classList.remove("active");
            page.inert = true;
        }
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    const checkBtn = document.querySelector(".js-check-btn");
    if (checkBtn) checkBtn.addEventListener("click", async ()=>{
        await $2b6e161c9edcf319$var$nextContentPage();
        await $2b6e161c9edcf319$var$startTermynal();
        await $2b6e161c9edcf319$var$nextContentPage();
    });
    const resultsBtn = document.querySelector(".js-results-btn");
    if (resultsBtn) resultsBtn.addEventListener("click", async ()=>{
        await $2b6e161c9edcf319$var$nextContentPage();
    });
    const copyMailBtn = document.querySelector(".js-copy-mail-btn");
    if (copyMailBtn) copyMailBtn.addEventListener("click", ()=>{
        const emailContent = document.querySelector(".js-email-content");
        if (emailContent) {
            const selection = $2b6e161c9edcf319$var$selectEmailContent();
            try {
                document.execCommand("copy");
                selection.removeAllRanges();
                const previousText = copyMailBtn.querySelector("span").textContent;
                copyMailBtn.querySelector("span").innerHTML = "<strong>SKOPIRANO!</strong>";
                setTimeout(()=>{
                    copyMailBtn.querySelector("span").textContent = previousText;
                }, 2000);
            } catch (err) {
                console.error("Failed to copy text: ", err);
            }
        }
    });
    const openMailBtn = document.querySelector(".js-open-mail-btn");
    if (openMailBtn) openMailBtn.addEventListener("click", ()=>{
        const selection = $2b6e161c9edcf319$var$selectEmailContent();
        const emailContent = selection.toString().trim();
        selection.removeAllRanges();
        const emailSubject = document.querySelector(".js-email-subject");
        const emailTo = document.querySelector(".js-email-to");
        if (emailContent && emailSubject && emailTo) {
            const mailtoLink = `mailto:${encodeURIComponent(emailTo.textContent.trim().replace(/\s+/g, ""))}?subject=${encodeURIComponent(emailSubject.textContent.trim())}&body=${encodeURIComponent(emailContent)}`;
            window.open(mailtoLink, "_blank");
        }
    });
    $2b6e161c9edcf319$var$loadResultValues();
    $2b6e161c9edcf319$var$addNewsletterListeners();
    $2b6e161c9edcf319$var$skipToExplanationIfNeeded();
    window.addEventListener("hashchange", ()=>{
        $2b6e161c9edcf319$var$skipToExplanationIfNeeded();
    });
});


//# sourceMappingURL=app.08ea88e5.js.map
